module.exports = __webpack_public_path__ + "img/8b93b85.png";